import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TKEY = "drnova_tokens";
const tokens = () => JSON.parse(localStorage.getItem(TKEY) || "{}");
const authHeader = (id) => ({ "X-Consult-Token": tokens()[id] || "" });

export const createConsultation = (body) => axios.post(`${API}/consultations`, body).then((r) => {
  const { token, ...c } = r.data;
  localStorage.setItem(TKEY, JSON.stringify({ ...tokens(), [c.id]: token }));
  return c;
});
export const getConsultation = (id) => axios.get(`${API}/consultations/${id}`, { headers: authHeader(id) }).then((r) => r.data);
export const markAdStarted = (id) => axios.post(`${API}/consultations/${id}/ad`, null, { headers: authHeader(id) });
const shrink = async (file, max = 1600) => {
  try {
    const bmp = await createImageBitmap(file);
    const k = Math.min(1, max / Math.max(bmp.width, bmp.height));
    const cv = Object.assign(document.createElement("canvas"), { width: Math.round(bmp.width * k), height: Math.round(bmp.height * k) });
    cv.getContext("2d").drawImage(bmp, 0, 0, cv.width, cv.height);
    return await new Promise((ok) => cv.toBlob((b) => ok(b || file), "image/jpeg", 0.88));
  } catch { return file; }
};
export const uploadPhoto = async (id, file) => {
  const fd = new FormData();
  fd.append("file", await shrink(file), "photo.jpg");
  return axios.post(`${API}/consultations/${id}/photos`, fd, { headers: authHeader(id) }).then((r) => r.data.id);
};
export const photoBlobUrl = (id, pid) => axios.get(`${API}/consultations/${id}/photos/${pid}`, { headers: authHeader(id), responseType: "blob" })
  .then((r) => URL.createObjectURL(r.data));
export const isRateLimited = (e) => e?.status === 429 || e?.response?.status === 429;

export async function streamPost(path, body, onDelta) {
  const id = path.split("/")[2];
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader(id) },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) throw Object.assign(new Error(`HTTP ${res.status}`), { status: res.status });
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  let final = {};
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const ev = JSON.parse(p.slice(6));
      if (ev.error) throw new Error(ev.error);
      if (ev.delta) onDelta(ev.delta);
      if (ev.done) final = ev;
    }
  }
  return final;
}

export function parseAssistant(text) {
  const m = text.match(/\[OPTIONS:([^\]]*)\]?/);
  const options = m ? m[1].split("|").map((s) => s.trim()).filter(Boolean) : [];
  const clean = text.replace(/\[OPTIONS:[^\]]*\]?/, "").replace("[READY]", "").trim();
  return { clean, options, ready: text.includes("[READY]") };
}

const HKEY = "drnova_history";
export const loadHistory = () => JSON.parse(localStorage.getItem(HKEY) || "[]");
export const saveHistoryItem = (item) => {
  const list = loadHistory().filter((h) => h.id !== item.id);
  localStorage.setItem(HKEY, JSON.stringify([item, ...list].slice(0, 50)));
};
export const clearHistory = () => { localStorage.removeItem(HKEY); localStorage.removeItem(TKEY); };
